import React, { useState, useEffect } from "react";
import { ChevronRight, ChevronDown, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import "./sectionArticle.css";

const SectionArticle = ({ summaryData }) => {
    const [openSections, setOpenSections] = useState({});

    useEffect(() => {
        if (summaryData && summaryData.structure) {
            const initialOpenState = {};
            summaryData.structure.forEach(section => {
                initialOpenState[section.id] = false;
            });
            setOpenSections(initialOpenState);
        }
    }, [summaryData]);

    const toggleSection = (sectionId) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    if (!summaryData || !summaryData.structure) {
        return <div className="sidebar-lois">Chargement de la structure...</div>;
    }

    return (
        <div className="sidebar-lois">
            {summaryData.structure.map((section) => (
                <div key={section.id} className="sidebar-section">
                    <div
                        className="section-header"
                        onClick={() => toggleSection(section.id)}
                    >
                        <BookOpen size={16} className="text-gray-600" />
                        <h3>{section.title}</h3>
                        {section.articles && section.articles.length > 0 && (
                            <span className="article-range">
                                {section.articles[0].number.replace("Article ", "")} à {
                                    section.articles[section.articles.length - 1].number.replace("Article ", "")
                                }
                            </span>
                        )}
                        {openSections[section.id] ? (
                            <ChevronDown size={18} className="text-gray-600" />
                        ) : (
                            <ChevronRight size={18} className="text-gray-600" />
                        )}
                    </div>
                    {openSections[section.id] && (
                        <div className="section-items">
                            {section.articles && section.articles.map((article) => (
                                <Link
                                    key={article.id}
                                    to={`/article/${article.id}?legal_text_id=${summaryData.legal_text_id || ''}`}
                                    className="section-item-link"
                                >
                                    <div className="section-item">
                                        {article.number}
                                    </div>
                                </Link>
                            ))}

                            {section.children && section.children.map((child) => (
                                <RenderChildSection
                                    key={child.id}
                                    child={child}
                                    legalTextId={summaryData.legal_text_id || ''}
                                />
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

const RenderChildSection = ({ child, legalTextId }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="nested-section">
            <div
                className="nested-header"
                onClick={() => setIsOpen(!isOpen)}
            >
                <BookOpen size={14} className="text-gray-600" />
                <h4>{child.title}</h4>
                {isOpen ? (
                    <ChevronDown size={16} className="text-gray-600" />
                ) : (
                    <ChevronRight size={16} className="text-gray-600" />
                )}
            </div>

            {isOpen && (
                <div className="nested-items">
                    {child.articles && child.articles.map((article) => (
                        <Link
                            key={article.id}
                            to={`/article/${article.id}?legal_text_id=${legalTextId}`}
                            className="section-item-link"
                        >
                            <div className="section-item">
                                {article.number}
                            </div>
                        </Link>
                    ))}

                    {child.children && child.children.map((subChild) => (
                        <RenderChildSection
                            key={subChild.id}
                            child={subChild}
                            legalTextId={legalTextId}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default SectionArticle;